export type SeasonSignupSubmission = {
  fastTrack: boolean;
  hasSavedSeason: boolean;
  submitLabel: "Create Your Profile" | "Create Profile and Add Season Later";
};

export function getSeasonSignupSubmission(
  savedSeasonCount: number,
): SeasonSignupSubmission {
  const hasSavedSeason = savedSeasonCount > 0;

  return {
    fastTrack: !hasSavedSeason,
    hasSavedSeason,
    submitLabel: hasSavedSeason
      ? "Create Your Profile"
      : "Create Profile and Add Season Later",
  };
}

export type AvailabilityDraft = {
  hasSelectedSeason: boolean;
  roleCount: number;
  availableFrom: string;
  availableTo: string;
};

export function getAvailabilityDraftError(
  draft: AvailabilityDraft,
): string | null {
  if (!draft.hasSelectedSeason) {
    return "Choose a season before adding availability.";
  }
  if (draft.roleCount === 0) {
    return "Choose at least one role for this availability window.";
  }
  if (
    !draft.availableFrom ||
    !draft.availableTo ||
    draft.availableFrom > draft.availableTo
  ) {
    return "Choose a valid start and end date.";
  }
  return null;
}

export function getPendingAvailabilityError(
  draft: AvailabilityDraft,
): string | null {
  if (!draft.hasSelectedSeason) return null;
  return (
    getAvailabilityDraftError(draft) ??
    "Add this availability before creating your account."
  );
}
